import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  BrowserRouter,
} from "react-router-dom";
import Dashboard from "./Components/Dashboard/Dashboard";
import Withdrawal_Payment_Reports from "./Components/Withdrawal/Withdrawal_Payment_Reports";
import Withdrawal_Pending_List from "./Components/Withdrawal/Withdrawal_Pending_List";
import Login from "./Components/Login/Login";
import OPT_Confirm from "./Components/Login/OPT_Confirm";
import WithdrawlStart_Stop from "./Components/Member/WithdrawlStart_Stop";
import Activation_History from "./Components/Member/Activation_History";
import Activation_Id_By_Zero_Pin from "./Components/Activation/Activation_Id_By_Zero_Pin";
import Zero_Pin_By_5050 from "./Components/Activation/Zero_Pin_By_5050";
import Message from "./Components/Dashboard Message/Message";
import Add_Coin from "./Components/Coin Management/Add_Coin";
import Coin_price from "./Components/Coin Management/Coin_price";
import MessageHistory from "./Components/Dashboard Message/MessageHistory";
import ProtectedRoute from "./Redux/actions/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Buy from "./Components/Trading/Buy";
import Sell from "./Components/Trading/Sell";
import TrandingWithdrawHistory from "./Components/Member/TrandingWithdrawHistory";
import Edit_details from "./Components/Member/Edit_details";
import HelpDesk from "./Components/HelpDesk/HelpDesk";
import Reply from "./Components/HelpDesk/Reply";
import Commission from "./Components/HelpDesk/Commission";
import LoginHistory from "./Components/HelpDesk/LoginHistory";
import Manage_subadmin from "./Components/Sub_Admin/Manage_subadmin";
import Subadmin_rights from "./Components/Sub_Admin/Subadmin_rights";
import Edit_subAdmin from "./Components/Sub_Admin/Edit_subAdmin";
import Add_subAdmin from "./Components/Sub_Admin/Add_subAdmin";
import My_Team from "./Components/Team_Reports/My team";
import Contact from "./Components/Contact/Contact";
import Add_HomePageCoin from "./Components/HomePageCoin/Add_HomePageCoin";
import HomePageCoinDetails from "./Components/HomePageCoin/HomePageCoinDetails";
import Update_HomePageCoin from "./Components/HomePageCoin/Update_HomePageCoin";
import RequestToken from "./Components/Request Token/RequestToken";
import RequestTokenUpdate from "./Components/Request Token/RequestTokenUpdate";
import RequestTokenPaid from "./Components/Request Token/RequestTokenPaid";
import RequestTokenCancel from "./Components/Request Token/RequestTokenCancel";
import Active_Member from "./Components/Member/ACTIVE_MEMBER_LIST";
import Level_detail from "./Components/Team_Reports/Level_detail";
import Direct_team from "./Components/Team_Reports/Direct_team";
import ActivationByAdmin from "./Components/Activation/ActivationByAdmin";
import All_member from "./Components/Member/All_member";
import ZeroPinActivation from "./Components/Zeropin Activation/ZeroPinActivation";
import ZeropinAHistory from "./Components/Zeropin Activation/ZeropinAHistory";
import RoiZeroPinA from "./Components/Zeropin Activation/RoiZeroPinA";
import UpgradeID from "./Components/Activation/UpgradeID";
import ActivationUHistory from "./Components/Activation/ActivationUHistory";
import UserActivationH from "./Components/Activation/UserActivationH";
import DirectLegBusiness from "./Components/Team_Reports/DirectLegBusiness";
import AddPowerleg from "./Components/Power Leg/AddPowerleg";
import PowerlegHis from "./Components/Power Leg/PowerlegHis";
import RoiRate from "./Components/Power Leg/RoiRate";
import ActivationFund from "./Components/Activation Fund/ActivationFund";
import AfundHistory from "./Components/Activation Fund/AfundHistory";
import ExpiredActivationFund from "./Components/Activation Fund/ExpiredActivationFund";
import ReferralLevelIncome from "./Components/Income Reports/ReferralLevelIncome";
import Direct_Income from "./Components/Income Reports/Direct_Income";
import LevelIncome from "./Components/Income Reports/LevelIncome";
import Salary_Income from "./Components/Income Reports/Salary_Income";
import TeamReward_income from "./Components/Income Reports/TeamReward_income";
import Total_incomeReport from "./Components/Income Reports/Total_incomeReport";
import RoiIncome from "./Components/Income Reports/RoiIncome";
import ClosedHelpDesk from "./Components/HelpDesk/ClosedHelpDesk";
import SubadminHistory from "./Components/Sub_Admin/SubadminHistory";
import UsdtBonusDetails from "./Components/QR Details/UsdtBonusDetails";
import PendingUsdtRequest from "./Components/QR Details/PendingUsdtRequest";
import UsdtContractHistory from "./Components/QR Details/UsdtContractHistory";
import DespsitHistory from "./Components/Request Token/DespsitHistory";
import Club_Income from "./Components/Income Reports/Club_Income";
import PaidRewardlist from "./Components/Income Reports/PaidRewardlist";
import IncometoFund from "./Components/Activation Fund/IncometoFund";
import PaidClaimCapitalWithdrawal from "./Components/Withdrawal/PaidClaimCapitalWithdrawal";
import PendingClaimCapitalWithdrawal from "./Components/Withdrawal/PendingClaimCapitalWithdrawal";
import TaskEntry from "./Components/Task/TaskEntry";
import TaskHistory from "./Components/Task/TaskHistory";
import UserTaskHistory from "./Components/Task/UserTaskHistory";
import UserTaskHistoryNew from "./Components/Task/UserTaskHistoryNew";
import BotActivationByAdmin from "./Components/Activation/BotActivationByAdmin";
import BinaryIncome from "./Components/Income Reports/BinaryIncome";
import DeductActivationFund from "./Components/Activation Fund/DeductActivationFund";
import Withdrawal_Pending_List_Tron from "./Components/Withdrawal/Withdrawal_Pending_List_Tron";
import CoinRateUpdate from "./Components/CoinRate/CoinRateUpdate";
import CoinRateUpdateHistory from "./Components/CoinRate/CoinRateUpdateHistory";
import NewCoin from "./Components/CoinRate/NewCoin";
import LotsTransfer from "./Components/Activation Fund/LotsTransfer";
import LotsTransferhistory from "./Components/Activation Fund/LotsTransferhistory";
import BulkLotsTransfer from "./Components/Activation Fund/BulkLotsTransfer";
import BotActivationHistory from "./Components/Activation/BotActivationHistory";
function App() {
  // useEffect(() => {
  //   const handleContextMenu = (event) => {
  //     event.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", handleContextMenu);

  //   document.addEventListener("keydown", (e) => {
  //     if (
  //       (e.ctrlKey &&
  //         (e.key === "I" ||
  //           e.key === "i" ||
  //           e.key === "u" ||
  //           e.key === "U" ||
  //           e.key === "J" ||
  //           e.key === "j" ||
  //           e.key === "C" ||
  //           e.key === "c")) ||
  //       e.key === "F12"
  //     ) {
  //       e.preventDefault();
  //     }
  //   });

  //   return () => {
  //     document.removeEventListener("contextmenu", handleContextMenu);
  //   };
  // }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer />
        <Routes>
          <Route />
          <Route exact path="/" element={<Login />} />
          <Route exact path="/OPT_Confirm" element={<OPT_Confirm />} />
          <Route
            exact
            path="/Dashboard"
            element={<ProtectedRoute component={Dashboard} />}
          />
          <Route
            exact
            path="/Allmember"
            element={<ProtectedRoute component={All_member} />}
          />
          <Route
            exact
            path="/Dashboard_Message"
            element={<ProtectedRoute component={Message} />}
          />
          <Route
            exact
            path="/MessageHistory"
            element={<ProtectedRoute component={MessageHistory} />}
          />

          {/* <Route
            exact
            path="/Coin_Changes"
            element={<ProtectedRoute component={Coin_Changes} />}
          />
          <Route
            exact
            path="/Base_Price"
            element={<ProtectedRoute component={Base_Price} />}
          />
          <Route
            exact
            path="/Change_History"
            element={<ProtectedRoute component={Add_power_leg} />}
          /> */}
          <Route
            exact
            path="/Member_Details"
            element={<ProtectedRoute component={Activation_History} />}
          />
          <Route
            exact
            path="/WithdrawlStart_Stop"
            element={<ProtectedRoute component={WithdrawlStart_Stop} />}
          />
          <Route
            exact
            path="/ActiveMember"
            element={<ProtectedRoute component={Active_Member} />}
          />
       

          <Route
            exact
            path="/Add_Funds"
            element={<ProtectedRoute component={Activation_Id_By_Zero_Pin} />}
          />
          <Route
            exact
            path="/zeropinA"
            element={<ProtectedRoute component={ZeroPinActivation} />}
          />
          <Route
            exact
            path="/zeropinAHistory"
            element={<ProtectedRoute component={ZeropinAHistory} />}
          />
          <Route
            exact
            path="/RoizeropinAHistory"
            element={<ProtectedRoute component={RoiZeroPinA} />}
          />
           <Route
            exact
            path="/BotActivation"
            element={<ProtectedRoute component={BotActivationByAdmin} />}
          />
          <Route
            exact
            path="/CoinRateUpdate"
            element={<ProtectedRoute component={CoinRateUpdate} />}
          />
          <Route
            exact
            path="/CoinRateUpdateHistory"
            element={<ProtectedRoute component={CoinRateUpdateHistory} />}
          />
          <Route
            exact
            path="/NewCoin"
            element={<ProtectedRoute component={NewCoin} />}
          />
          
          <Route
            exact
            path="/Activation"
            element={<ProtectedRoute component={ActivationByAdmin} />}
          />
         
         
          <Route
            exact
            path="/upgradeid"
            element={<ProtectedRoute component={UpgradeID} />}
          />
          <Route
            exact
            path="/Activationhistory"
            element={<ProtectedRoute component={ActivationUHistory} />}
          />
          <Route
            exact
            path="/BotActivationHistory"
            element={<ProtectedRoute component={BotActivationHistory} />}
          />
          <Route
            exact
            path="/DespsitHistory"
            element={<ProtectedRoute component={DespsitHistory} />}
          />

          <Route
            exact
            path="/userActivationhistory"
            element={<ProtectedRoute component={UserActivationH} />}
          />
         
          <Route
            exact
            path="/roirate"
            element={<ProtectedRoute component={RoiRate} />}
          />
          <Route
            exact
            path="/addpower"
            element={<ProtectedRoute component={AddPowerleg} />}
          />
          <Route
            exact
            path="/powerhistory"
            element={<ProtectedRoute component={PowerlegHis} />}
          />
          <Route
            exact
            path="/activationfund"
            element={<ProtectedRoute component={ActivationFund} />}
          />
          <Route
            exact
            path="/deductactivationfund"
            element={<ProtectedRoute component={DeductActivationFund} />}
          />
          <Route
            exact
            path="/activationfundHis"
            element={<ProtectedRoute component={AfundHistory} />}
          />
             <Route
            exact
            path="/IncometoFundHis"
            element={<ProtectedRoute component={IncometoFund} />}
          />
          <Route
            exact
            path="/expireactivation"
            element={<ProtectedRoute component={ExpiredActivationFund} />}
          />
          <Route
            exact
            path="/Deduct_Funds"
            element={<ProtectedRoute component={Zero_Pin_By_5050} />}
          />
          <Route
            exact
            path="/Funds_Details"
            element={<ProtectedRoute component={Direct_Income} />}
          />
          {/* <Route
            exact
            path="/bonus"
            element={<ProtectedRoute component={Bonus} />}
          /> */}
          <Route
            exact
            path="/Withdrawal_History"
            element={<ProtectedRoute component={Withdrawal_Payment_Reports} />}
          />
                   
         
          <Route
            exact
            path="/Pending_Withdrawal"
            element={<ProtectedRoute component={Withdrawal_Pending_List} />}
          />
          
          <Route
            exact
            path="/Pending_Withdrawal_Tron"
            element={<ProtectedRoute component={Withdrawal_Pending_List_Tron} />}
          />
     
     
<Route exact path="/PaidRewardlist" element={<ProtectedRoute  component={PaidRewardlist}/>}/>
        
          <Route
            exact
            path="/Add_Coin"
            element={<ProtectedRoute component={Add_Coin} />}
          />
          <Route
            exact
            path="/Coin_Base_Price"
            element={<ProtectedRoute component={Coin_price} />}
          />
          <Route
            exact
            path="/Buy"
            element={<ProtectedRoute component={Buy} />}
          />
          <Route
            exact
            path="/Sell"
            element={<ProtectedRoute component={Sell} />}
          />
       
       

          <Route
            exact
            path="/Cancel_Withdrawal"
            element={<ProtectedRoute component={TrandingWithdrawHistory} />}
          />
          <Route
            exact
            path="/Edit_Details"
            element={<ProtectedRoute component={Edit_details} />}
          />
          <Route
            exact
            path="/HelpDesk"
            element={<ProtectedRoute component={HelpDesk} />}
          />
          <Route
            exact
            path="/ClosedHelpDesk"
            element={<ProtectedRoute component={ClosedHelpDesk} />}
          />
          <Route
            exact
            path="/Reply"
            element={<ProtectedRoute component={Reply} />}
          />
          <Route
            exact
            path="/PendingReward"
            element={<ProtectedRoute component={RequestToken} />}
          />
          <Route
            exact
            path="/PaidRewardHistory"
            element={<ProtectedRoute component={RequestTokenPaid} />}
          />
          <Route
            exact
            path="/RequestTokenUpdate"
            element={<ProtectedRoute component={RequestTokenUpdate} />}
          />
          <Route
            exact
            path="/Commission_Report"
            element={<ProtectedRoute component={Commission} />}
          />
          <Route
            exact
            path="/LoginHistory"
            element={<ProtectedRoute component={LoginHistory} />}
          />
          {/* <Route exact path="/ApprovedKyc" element={<ProtectedRoute component={ApprovedKyc}/>} />
        <Route exact path="/PendingKyc" element={<ProtectedRoute component={PendingKyc}/>} /> */}
          <Route
            exact
            path="/Manage_subadmin"
            element={<ProtectedRoute component={Manage_subadmin} />}
          />
          <Route
            exact
            path="/Subadmin_rights"
            element={<ProtectedRoute component={Subadmin_rights} />}
          />
          <Route
            exact
            path="/Edit_SubAdmin"
            element={<ProtectedRoute component={Edit_subAdmin} />}
          />
          <Route
            exact
            path="/Add_SubAdmin"
            element={<ProtectedRoute component={Add_subAdmin} />}
          />
          <Route
            exact
            path="/ReferralLevelIncome"
            element={<ProtectedRoute component={ReferralLevelIncome} />}
          />
          <Route
            exact
            path="/Direct_Income"
            element={<ProtectedRoute component={Direct_Income} />}
          />
          {/* <Route
            exact
            path="/Booster_Income"
            element={<ProtectedRoute component={Booster_Income} />}
          /> */}
          <Route
            exact
            path="/LevelIncome"
            element={<ProtectedRoute component={LevelIncome} />}
          />
          <Route
            exact
            path="/RoiIncome"
            element={<ProtectedRoute component={RoiIncome} />}
          />
             <Route
            exact
            path="/Club_Income"
            element={<ProtectedRoute component={Club_Income} />}
          />
          <Route
            exact
            path="/Salary_Income"
            element={<ProtectedRoute component={Salary_Income} />}
          />
        
          <Route
            exact
            path="/TeamReward_income"
            element={<ProtectedRoute component={TeamReward_income} />}
          />
          <Route
            exact
            path="/Total_incomeReport"
            element={<ProtectedRoute component={Total_incomeReport} />}
          />

          {/* <Route exact path="/Add_MarketCoin" element={<ProtectedRoute component={Add_MarketCoin}/>} /> 
        <Route exact path="/MarketCoinHistory" element={<ProtectedRoute component={MarketCoinHistory}/>} /> 
        <Route exact path="/Update_Coin_Details" element={<ProtectedRoute component={UpdateCoin}/>}/> */}
          <Route
            exact
            path="/My_Team"
            element={<ProtectedRoute component={My_Team} />}
          />
          <Route
            exact
            path="/myreferrals"
            element={<ProtectedRoute component={Direct_team} />}
          />
          <Route
            exact
            path="/DirectLegBusiness"
            element={<ProtectedRoute component={DirectLegBusiness} />}
          />
         
      
          <Route
            exact
            path="/levelDetails"
            element={<ProtectedRoute component={Level_detail} />}
          />
          <Route
            exact
            path="/Contact_Query"
            element={<ProtectedRoute component={Contact} />}
          />
          <Route
            exact
            path="/Add_HomePageCoin"
            element={<ProtectedRoute component={Add_HomePageCoin} />}
          />
          <Route
            exact
            path="/HomePageCoinDetails"
            element={<ProtectedRoute component={HomePageCoinDetails} />}
          />
          <Route
            exact
            path="/Update_HomePageCoin"
            element={<ProtectedRoute component={Update_HomePageCoin} />}
          />
          <Route
            exact
            path="/RequestTokenCancel"
            element={<ProtectedRoute component={RequestTokenCancel} />}
          />
          {/* <Route
            exact
            path="/Team_Business"
            element={<ProtectedRoute component={Team_Business} />}
          /> */}
          {/* <Route
            exact
            path="/Team_Business_Retopup"
            element={<ProtectedRoute component={Team_Business_Retopup} />}
          /> */}

          <Route
            exact
            path="/UsdtqrDetails"
            element={<ProtectedRoute component={UsdtBonusDetails} />}
          />
          <Route
            exact
            path="/PendingQRRequest"
            element={<ProtectedRoute component={PendingUsdtRequest} />}
          />
          <Route
            exact
            path="/qrHistory"
            element={<ProtectedRoute component={UsdtContractHistory} />}
          />
          <Route
            exact
            path="/SubadminHistory"
            element={<ProtectedRoute component={SubadminHistory} />}
          />
           <Route
            exact
            path="/PaidClaimCapitalWithdrawal"
            element={<ProtectedRoute component={PaidClaimCapitalWithdrawal} />}
          />
           <Route
            exact
            path="/PendingClaimCapitalWithdrawal"
            element={<ProtectedRoute component={PendingClaimCapitalWithdrawal} />}
          />
          <Route
            exact
            path="/TaskEntry"
            element={<ProtectedRoute component={TaskEntry} />}
          />
          <Route
            exact
            path="/TaskHistory"
            element={<ProtectedRoute component={TaskHistory} />}
          />
           <Route
            exact
            path="/UserTaskHistory"
            element={<ProtectedRoute component={UserTaskHistory} />}
          />
          <Route
            exact
            path="/UserTaskHistoryNew"
            element={<ProtectedRoute component={UserTaskHistoryNew} />}
          />
          <Route
            exact
            path="/BinaryIncome"
            element={<ProtectedRoute component={BinaryIncome} />}
          />
             <Route
            exact
            path="/LotsTransfer"
            element={<ProtectedRoute component={LotsTransfer} />}
          />
           <Route
            exact
            path="/LotsTransferhistory"
            element={<ProtectedRoute component={LotsTransferhistory} />}
          />
            <Route
            exact
            path="/BulkLotsTransfer"
            element={<ProtectedRoute component={BulkLotsTransfer} />}
          />
        </Routes>
        
      </BrowserRouter>
    </div>
  );
}

export default App;
